import { render, staticRenderFns } from "./weibo.vue?vue&type=template&id=3df62b4c&"
import script from "./weibo.vue?vue&type=script&lang=ts&"
export * from "./weibo.vue?vue&type=script&lang=ts&"
import style0 from "./weibo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports